import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FaBars } from "react-icons/fa";
import { logoutAction } from "../../store/actions/auth.action";
import { ERoutes } from "../../enums/routes";
import { authSelector } from "../../store/selectors";
import "./header.css";
// import logo from "../../assets/img/logos.png"; // Update the path as per your project structure
import { getSiteRefrence } from "../../api/endpoints/refrences";

const Header = () => {
  const { user, access_token } = useSelector(authSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const logout = () => {
    dispatch(logoutAction());
    navigate("/");
  };

  const [state, setState] = useState({
    siteName: "",
    siteAddress: "",
    siteDealer: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      const siteNameAddress = await getSiteRefrence(access_token);

      if (siteNameAddress.success) {
        setState((prev) => ({
          ...prev,
          siteName: siteNameAddress.data.siteName,
          siteAddress: siteNameAddress.data.siteAddress,
          siteDealer: siteNameAddress.data.siteDealer,
        }));
      }
    };

    fetchData();
  }, [access_token]);

return (
  <nav className="background shadow-md">
    <div className="container mx-auto px-4 py-3 grid grid-cols-3 items-center">

      {/* LEFT: Logo */}
      <div className="flex items-center gap-2">
        <img
          src="./assets/logos.png"
          alt="Logo"
          className="h-10 w-10"
        />
        <span className="hidden sm:block font-bold text-black">
          IT WORLD
        </span>
      </div>

      {/* CENTER: Site Name */}
      <div className="text-center">
        <h1 className="text-lg sm:text-2xl md:text-3xl font-extrabold 
          text-transparent bg-clip-text 
          bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500 
          tracking-wide">
          {state.siteName}
        </h1>
        {/* <p className="text-[10px] sm:text-xs text-gray-700 tracking-widest">
          Fuel Management System
        </p> */}
      </div>

      {/* RIGHT: Menu */}
      <div className="flex justify-end items-center">
        <button onClick={toggleDropdown} className="sm:hidden">
          <FaBars className="text-black text-2xl" />
        </button>

        <ul
          className={`
            ${isDropdownOpen ? "block" : "hidden"}
            sm:flex sm:items-center
            absolute sm:static
            top-16 right-4 sm:right-0
            w-52 sm:w-auto
            bg-white sm:bg-transparent
            shadow-lg sm:shadow-none
            rounded-lg sm:rounded-none
            p-3 sm:p-0
            z-50
          `}
        >
          {user.role === "admin" && (
            <Link to="/saleRegister">
              <li className={`px-3 py-2 hover:text-blue-600 ${
                pathname === ERoutes.SALE_REGISTER ? "font-bold underline" : ""
              }`}>
                Sale Detail
              </li>
            </Link>
          )}

          {user.role === "admin" && (
            <>
              <Link to="/tankData">
                <li className={`px-3 py-2 hover:text-blue-600 ${
                  pathname === ERoutes.TANK_DATA ? "font-bold underline" : ""
                }`}>
                  Tank Stock
                </li>
              </Link>

              <Link to="/item">
                <li className={`px-3 py-2 hover:text-blue-600 ${
                  pathname === ERoutes.ITEM ? "font-bold underline" : ""
                }`}>
                  Item 
                </li>
              </Link>
            </>

          )}

          <Link to="/saleData">
            <li className={`px-3 py-2 hover:text-blue-600 ${
              pathname === ERoutes.SALE_DATA ? "font-bold underline" : ""
            }`}>
              Sale Data
            </li>
          </Link>

          <li
            onClick={logout}
            className="px-3 py-2 cursor-pointer hover:text-red-500"
          >
            Logout
          </li>
        </ul>
      </div>
    </div>
  </nav>
);
};

export default Header;
